import React from 'react';
import { StarIcon } from '@heroicons/react/24/outline';
import { GamePlayMilestonePayload } from '../../../generated-api';
import { CompactEventRow } from './CompactEventRow';

interface GamePlayMilestoneCardProps {
  payload: GamePlayMilestonePayload;
  createdAt: string;
}

export const GamePlayMilestoneCard: React.FC<GamePlayMilestoneCardProps> = ({ payload, createdAt }) => (
  <CompactEventRow
    track="feed_game_milestone_card"
    to={`/games/${payload.gameId}`}
    icon={<StarIcon className="h-4 w-4" />}
    iconClassName="bg-indigo-100 text-indigo-600"
    label="Game Milestone"
    createdAt={createdAt}
    thumbnail={payload.gameImage}
  >
    <span className="font-medium text-heading">{payload.gameName}</span>
    {' played '}
    <span className="font-semibold text-indigo-600">{payload.milestone} times</span>
  </CompactEventRow>
);
